import { createVuetify } from "vuetify"

// 既存デザインを維持するため、Vuetifyはダイアログ等の動作にのみ使う。
// グローバルCSS（vuetify/styles）は読み込まず、テーマもOS設定に追従させない
export default createVuetify({
    theme: {
        defaultTheme: "light",
    },
})
